// extracted by mini-css-extract-plugin
export var button = "_e8-4";
export var hasDarkBackground = "_e8-7";
export var hasLightBackground = "_e8-6";
export var iconWrapper = "_e8-0";
export var large = "_e8-2";
export var medium = "_e8-1";
export var small = "_e8-5";
export var xsmall = "_e8-3";